/**
 * One-way migration: splideOptions → carouselOptions.
 *
 * Renames Splide-specific keys to Embla-compatible names,
 * converts focus→align for old blocks, and drops unused keys.
 * Used by the editor auto-migration effect and deprecated.js.
 */

const PASS_THROUGH = [
	'type',
	'perPage',
	'fixedWidth',
	'gap',
	'autoplay',
	'arrows',
	'pagination',
	'progressBar',
	'counter',
	'destroy',
];

function migrateLevel( opts ) {
	if ( ! opts || typeof opts !== 'object' ) return {};

	const out = {};

	// Pass-through keys (unchanged names).
	for ( const key of PASS_THROUGH ) {
		if ( opts[ key ] !== undefined ) {
			out[ key ] = opts[ key ];
		}
	}

	// align (new) takes precedence over focus (legacy).
	if ( opts.align !== undefined ) {
		out.align = opts.align;
	} else if ( opts.focus !== undefined ) {
		out.align = opts.focus === 'center' ? 'center' : 'start';
	}

	// perMove → slidesToScroll
	if ( opts.perMove !== undefined ) {
		out.slidesToScroll = parseInt( opts.perMove, 10 ) || 1;
	}

	// omitEnd → containScroll
	if ( opts.omitEnd !== undefined ) {
		out.containScroll = opts.omitEnd ? 'trimSnaps' : false;
	}

	// Dropped: autoHeight, mediaQuery, rewind (not used by Embla)

	return out;
}

/**
 * Convert a full splideOptions attribute (with breakpoints) to carouselOptions format.
 *
 * @param {Object} splideOptions - The raw splideOptions attribute value.
 * @return {Object} carouselOptions-compatible object.
 */
export function migrateSplideOptions( splideOptions ) {
	if ( ! splideOptions || typeof splideOptions !== 'object' ) return {};

	const result = migrateLevel( splideOptions );

	if ( splideOptions.breakpoints && typeof splideOptions.breakpoints === 'object' ) {
		result.breakpoints = {};
		for ( const [ bpName, bpOpts ] of Object.entries( splideOptions.breakpoints ) ) {
			const mapped = migrateLevel( bpOpts );
			if ( Object.keys( mapped ).length > 0 ) {
				result.breakpoints[ bpName ] = mapped;
			}
		}
		if ( Object.keys( result.breakpoints ).length === 0 ) {
			delete result.breakpoints;
		}
	}

	return result;
}
